export const notificationsConst = {
    OPEN: 'NOTIFICATIONS_OPEN',
    CLOSE: 'NOTIFICATIONS_CLOSE'
};
